module.exports = __webpack_public_path__ + "static/media/half.d4b18684.png";